import { getPropositions } from '@rei/adobe-target-functions';

const AdobeTarget = {
  async getExperience(experienceName) {
    try {
      const data = await getPropositions(['__view__']);

      return data
        .filter((item) => item.format === 'application/json')
        .find((x) => x.content.experimentName === experienceName)?.content?.experience;
    } catch (error) {
      console.error('Error with Adobe Target', error);
      return null;
    }
  },
};

export default AdobeTarget;
